module.exports = __webpack_public_path__ + "static/scale-model-of-corona-california-4a06ddbf0405c983effb0ad6ea601f24.png";